import React from 'react';
import { observer } from 'mobx-react';
import { NikoTemplateCreateModalTemplate } from 'themes/application/niko-patient/components';
import { setCurrentView } from 'core/utils';
import { NikoCreateTemplateModalStore } from 'application/niko-patient/stores';

@setCurrentView((rootStore, componentProps) => new NikoCreateTemplateModalStore(rootStore, componentProps), 'nikoCreateTemplateModalStore')
@observer
class NikoTemplateCreateModal extends React.Component {
    render() {
        return <NikoTemplateCreateModalTemplate {...this.props} />
    }
}

export default NikoTemplateCreateModal;